module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == '1') ? _c('b2c', {
    attrs: {
      "type": 'newContract'
    }
  }) : _c('b2b', {
    attrs: {
      "type": 'newContract'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-05d19ffa!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/choose-new-plan.vue
// module id = 2040
// module chunks = 1